<p-toast />
<div class="tw:h-full tw:flex tw:flex-col tw:p-4 tw:gap-4">
  <header class="tw:flex tw:items-center tw:justify-between tw:gap-2 tw:shrink-0">
    <img
      ngSrc="logo-crm.svg"
      priority
      width="168"
      height="32"
      alt="Pinnakl CRM"
    />
    @if (showProfileMenu()) {
      <lib-header-user-profile />
    }
  </header>
  <div class="tw:flex tw:flex-col tw:flex-1 tw:min-h-0 tw:overflow-hidden">
    <router-outlet></router-outlet>
  </div>
</div>
